import { ResponsiveContainer } from '@arpeggi/ui'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { styled } from '../../../lib/stitches'
import Button from '../../core/Button/Button'
import { Box } from '../../core/Components'
import { DiscordLogo, InstagramLogo, TwitterLogo } from '../../core/icons'
import Text from '../../core/Text/Text'
import { PUBLIC_NOTION_URL } from '../constants'
import { ArpeggiLogo } from '../icons'

const FooterContainer = styled('div', {
  marginTop: '80px',
  padding: '32px',
  height: '134px',
  background: '$background__secondary',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch'
})

const StyledLogo = styled(ArpeggiLogo, { marginRight: '$10' })

const LogoText = styled(Text, {
  display: 'flex',
  fontFamily: '$poppins',
  defaultVariants: { size: '16' }
})

const LINKS: { label: string; url: string; external?: boolean }[] = [
  { label: 'Studio', url: '/studio' },
  { label: 'Home', url: '/' },
  { label: 'Learn', url: PUBLIC_NOTION_URL, external: true },
  { label: 'Genesis Studio', url: '/genesis-studio' },
  { label: 'Terms of Service', url: '/legal/terms-of-service' }
]

export const DISCORD_LINK = 'https://discord.com/invite/yBxhcBwNyg'
export const TWITTER_URL = 'https://twitter.com/arpeggi_labs'
export const INSTAGRAM_URL = 'https://www.instagram.com/arpeggi_labs'

const Discord = styled(DiscordLogo, {
  color: '$text__primary',
  margin: '0px 4px'
})
const Twitter = styled(TwitterLogo, {
  color: '$text__primary',
  margin: '0px 4px'
})
const Instagram = styled(InstagramLogo, {
  color: '$text__primary',
  margin: '0px 4px'
})

const Footer: FC = () => {
  return (
    <FooterContainer>
      <Box>
        <ResponsiveContainer
          css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <LogoText css={{ fontWeight: '$semibold', whiteSpace: 'nowrap' }}>
            <StyledLogo />
            Arpeggi Labs
          </LogoText>
          <Box css={{ display: 'none', alignItems: 'center', '@tablet': { display: 'flex' } }}>
            {LINKS.map((e) =>
              e.external ? (
                <a href={e.url} key={e.url}>
                  <Button>{e.label}</Button>
                </a>
              ) : (
                <Link to={e.url} key={e.url}>
                  <Button>{e.label}</Button>
                </Link>
              )
            )}
          </Box>
          <Box css={{ display: 'flex', alignItems: 'center' }}>
            <a href={DISCORD_LINK}>
              <Discord />
            </a>
            <a href={TWITTER_URL}>
              <Twitter />
            </a>
            <a href={INSTAGRAM_URL}>
              <Instagram />
            </a>
          </Box>
        </ResponsiveContainer>
      </Box>
    </FooterContainer>
  )
}

export default Footer
